export default "__VITE_ASSET__508441dd__"